import { Component, Inject } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ConfigStorage, UserStorage } from "@scisys-uim/uim-common";
import { FirearmAssignablePersonService, FirearmAssignmentLogService, FirearmPoolService, FirearmService, FirearmStorageLocationService } from "assets-service";
import { FirearmStorageAssignmentCreationDialogComponent, FirearmStorageAssignmentCreationDialogConfigData, FirearmStorageAssignmentCreationDialogData } from "./firearm-storage-assignment-creation-dialog.component";
import { FIREARM_TYPE } from "assets-model";



export interface FirearmAcquireDialogData extends FirearmStorageAssignmentCreationDialogData {
}

export interface FirearmAcquireDialogConfigData extends FirearmStorageAssignmentCreationDialogConfigData {
}

@Component({
  selector: 'app-firearm-acquire-dialog',
  templateUrl: './firearm-acquire-dialog.component.html',
  styleUrls: ['./firearm-acquire-dialog.component.scss']
})
export class FirearmAcquireDialogComponent extends FirearmStorageAssignmentCreationDialogComponent {

  get firearmTypeName(): string {
    return FIREARM_TYPE.typeName(this.data?.firearm);
  }

  constructor(
    dialogRef: MatDialogRef<FirearmAcquireDialogComponent, FirearmAcquireDialogData>,
    @Inject(MAT_DIALOG_DATA) data: FirearmAcquireDialogConfigData,
    fb: FormBuilder,
    dialog: MatDialog,
    firearmService: FirearmService,
    firearmAssignmentLogService: FirearmAssignmentLogService,
    firearmAssignablePersonService: FirearmAssignablePersonService,
    firearmStorageLocationService: FirearmStorageLocationService,
    firearmPoolService: FirearmPoolService,
    configService: ConfigStorage,
    userStorage: UserStorage) {
    super(dialogRef, data, fb, dialog, firearmService, firearmAssignmentLogService, firearmAssignablePersonService, firearmStorageLocationService, firearmPoolService, configService, userStorage);
  }

  protected isStorageAssigneeRequired() {
    return true;
  }
  protected isLocationRequired() {
    return false;
  }
  protected isCommentRequired() {
    return true;
  }

  locationSelectionListLoaded() {
    if (this.data?.firearm?.asset?.location != null && this.locationSelectionList != null) {
      var selectedLocation = this.locationSelectionList.find(l => l.location == this.data?.firearm?.asset?.location);
      if (selectedLocation != null) {
        this.item.location = selectedLocation;
      }
    }
  }

  isFirearmAcquireEnabled() {
    return this.isFirearmStorageAssignmentCreationEnabled();
  }

  firearmAcquire() {
    this.firearmService.acquireFirearm({
      assetId: this.data.firearm?.assetId,
      storageAssignee: {
        personId: this.item?.storageAssignee?.personId,
        username: this.item?.storageAssignee?.user?.user
      },
      locationId: this.item?.location?.firearmStorageLocationId,
      comments: this.item.comments
    }).subscribe(result => {
      this.item.firearm = result;
      this.dialogRef.close(this.item);
    });
  }

}
